import { useRef, useEffect } from 'react'
import anime from 'animejs'
import { Box } from '@chakra-ui/react'

import { ReactComponent as Image } from '@/svg/services/lawyer-rafiki.svg'

interface Props {
  animate?: boolean
}

function CCTVPoliciesImage({ animate = true }: Props): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current && animate) {
      const containerClassName = containerRef.current.className
        .split(' ')
        .join('.')

      const animInstances: anime.AnimeInstance[] = []
      const animateConfig = {
        easing: 'spring(1, 100, 30, 0)',
        direction: 'alternate',
        loop: true,
        duration: 1000,
        delay: 350,
        endDelay: 350,
      }

      const delayFunction = () => anime.random(5, 15) * 300

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #banner-1`,
          scale: [0, 1],
          opacity: [0, 1],
          delay: delayFunction,
          endDelay: delayFunction,
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #banner-2`,
          scale: [0, 1],
          opacity: [0, 1],
          delay: delayFunction,
          endDelay: delayFunction,
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #banner-3`,
          scale: [0, 1],
          opacity: [0, 1],
          delay: delayFunction,
          endDelay: delayFunction,
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #banner-4`,
          scale: [0, 1],
          opacity: [0, 1],
          delay: delayFunction,
          endDelay: delayFunction,
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #head`,
          rotate: ['-1deg', '1deg'],
          transformOrigin: ['70% 12%', '70% 12%'],
          easing: 'easeInOutSine',
        }),
      )

      return () =>
        animInstances.forEach((instance: anime.AnimeInstance) =>
          instance.pause(),
        )
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {}
  }, [containerRef.current, animate])

  return (
    <Box
      ref={containerRef}
      sx={{
        '& *': { transformOrigin: '70% 30%' },
      }}
    >
      <Image />
    </Box>
  )
}
export default CCTVPoliciesImage
